const KEEPS_LINE_SELECTION_ATTRIBUTE = "data-keeps-line-selection";

export const lineSelectionKeeperProps = { [KEEPS_LINE_SELECTION_ATTRIBUTE]: true };

const selectionKeeperSelector = `[${KEEPS_LINE_SELECTION_ATTRIBUTE}], .MuiModal-root, .MuiPopper-root`;

export const keepsLineSelection = (target: EventTarget | null, editor: HTMLElement | null): boolean =>
  target instanceof Element && (editor?.contains(target) === true || target.closest(selectionKeeperSelector) !== null);
